module.exports = __webpack_public_path__ + "src/assets/games/19/100.jpg";